import styled, { css } from 'styled-components';
import media from 'styled-media-query';

import { fontSize } from '../../shared/styles/mixins';
import { steel, greyishBrown } from '../../shared/styles/colors';

import { Paragraph } from '../Paragraph/styled';

export const Wrapper = styled.section`
	font-family: 'Montserrat';
	font-weight: 400;
	color: #121A3D;
    border-top: 1px solid #E9F0F8;
    padding: 32px 70px 32px 300px;
	@media(max-width: 600px) {
		padding: 20px 32px;
	}
`;

export const Header = styled.header`
	display: flex;
	justify-content: space-between;
	strong {
		font-size: 1rem;
	}
	p {
		font-size: .75rem;
		color: #505050;
		margin-top: 4px;
	}
`;
export const Title = styled.span``;
export const Link = styled.a`
	color: #008EFF;
    text-decoration: underline;
    font-weight: 600;
    margin-top: 36px;
    display: block;
	cursor: pointer;
`;
